import axios from 'axios';

//let url = 'http://localhost/luckybackend/'
//let pic = 'http://localhost/luckybackend/upload'

let url = 'https://luckyresortkpp.com/luckybackend/'
let pic = 'https://luckyresortkpp.com/luckybackend/upload'


const api = axios.create({
  baseURL: url
});

const apipic = axios.create({
  baseURL: pic
});

const URL = axios.create({

  // baseURL: 'https://e-student.kpru.ac.th/refund/api/'
  baseURL: 'https://e-student.kpru.ac.th/tess/'
 // baseURL: 'http://localhost:3000/adminconference-sd'
 });

const apilogin = axios.create({
//baseURL: 'https://e-student.kpru.ac.th/refund/api/',
baseURL: 'hhttps://admission.kpru.ac.th/refund/api/',
//baseURL: 'http://localhost:5000/api/',
  headers: {
    'Authorization': 'Bearer ' + window.localStorage.getItem('auth')
  }
});


export { api, apilogin, URL, apipic };
